import React from "react"
import PropTypes from "prop-types"
import { Container, Content, Badge, Icon, Name, Bar, Selected, ProfileSelected } from "./styles"

const Item = ({
  name,
  label,
  icon,
  badge,
  clickHandler,
  isSelected,
  setSelected,
  first,
  last,
  compact,
  transparent,
  profile
}) => {
  const sharedProps = {
    selected: !!isSelected,
    compact: !!compact,
    transparent: !!transparent,
    profile: !!profile
  }

  const handleClick = (event) => {
    if (setSelected !== undefined) setSelected(name)
    if (clickHandler !== undefined) clickHandler(event)
  }

  return (
    <Container onClick={handleClick} {...sharedProps}>
      <Content {...sharedProps}>
        {icon && <Icon {...sharedProps} size="1x" icon={icon} />}
        {profile && <ProfileSelected {...sharedProps}></ProfileSelected>}
        <Name {...sharedProps}>{label}</Name>
        {badge && <Badge {...sharedProps}>{badge}</Badge>}
      </Content>

      {!profile && (
        <Bar first={!!first} last={!!last} {...sharedProps}>
          <Selected {...sharedProps}></Selected>
        </Bar>
      )}
    </Container>
  )
}

Item.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  badge: PropTypes.number,
  icon: PropTypes.object,
  clickHandler: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  setSelected: PropTypes.func.isRequired,
  first: PropTypes.bool.isRequired,
  last: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  transparent: PropTypes.bool.isRequired
}

Item.defaultProps = {
  name: "",
  label: "",
  clickHandler: undefined,
  isSelected: false,
  setSelected: undefined,
  first: false,
  last: false,
  compact: false,
  transparent: false
}

export default Item
